<homey-page-title title="Login"/>
<div>
  @if (loginResult()) {
    @if (loginResult() && loginResult() !== 'success') {
      @switch (loginResult()) {
        @case ('invalid-email') {
          <homey-error-message>A user with the given email does not exist. Ensure you use the correct capitalization.
          </homey-error-message>
        }
        @case ('google-account') {
          <homey-error-message>You created this account with Google, please use the Google login button.
          </homey-error-message>
        }
        @case ('apple-account') {
          <homey-error-message>You created this account with Apple, please use the Apple login button.
          </homey-error-message>
        }
        @case ('invalid-password') {
          <homey-error-message>Invalid password.</homey-error-message>
        }
      }
    }
  }
  <homey-custom-form [formGroup]="form" submitButtonLabel="Continue" [submitFunction]="submit">
    <homey-form-inputs>
      <homey-text-input [inputFormControl]="form.controls.email"
                        inputId="email"
                        label="Email address"
                        type="email"/>
      <div>
        <homey-text-input class="block mb-2" [inputFormControl]="form.controls.password"
                          inputId="password"
                          label="Password"
                          [showPasswordToggle]="true"
                          [type]="{
                        type: 'password',
                        autocomplete: 'current-password'
                      }"
        />
        <a [routerLink]="['forgot-password']" class="underline">Forgot password?</a>
      </div>
      <homey-terms-conditions-checkbox [formControlInput]="form.controls.conditions"/>
    </homey-form-inputs>
  </homey-custom-form>
</div>
<p-divider align="center" [dt]="whiteDividerDt">
  <p class="text-surface-500">or</p>
</p-divider>
<homey-login-with-google-button
  [agreedToTerms]="form.controls.conditions.getRawValue()" [oathState]="
    {redirectUrl: redirectUrlWithFallback(), initialFormCommand: undefined}
"/>
<homey-login-with-apple-button
  class="mt-2"
  [agreedToTerms]="form.controls.conditions.getRawValue()" [oathState]="
    {redirectUrl: redirectUrlWithFallback(), initialFormCommand: undefined}
"/>

<p class="mt-auto text-sm text-muted-color">Don't have an account?   <a [routerLink]="initialSignupRoute" class="underline">Sign up!</a></p>
<p class="text-muted-color text-sm mt-0.5">Trouble signing in?
  <button (click)="helpVisible.set(true)" class="underline">Click here</button>
</p>

<p-dialog [(visible)]="helpVisible">
  <ng-template pTemplate="header">
    <h2 class="text-lg font-semibold">Trouble signing in?</h2>
  </ng-template>
  <ng-template pTemplate="content">
    Let us know what went wrong, we'll get back to within 24 hours.
    <homey-custom-form submitButtonLabel="Send" [formGroup]="questionForm" [submitFunction]="submitHelp">
      <homey-form-inputs class="mt-2">
        <homey-text-input label="Your Name" inputId="name" [type]="{
      type: 'text',
      autocomplete: 'given-name',
    }" [inputFormControl]="questionForm.controls.name"/>
        <homey-text-input label="Your Email" inputId="name" type="email"
                          [inputFormControl]="questionForm.controls.email"/>
        <p-floatlabel variant="on">
          <textarea pTextarea id="message" rows="7" cols="30" style="resize: none" class="w-full"
                    [formControl]="questionForm.controls.message"></textarea>
          <label for="message">Your Message</label>
        </p-floatlabel>
      </homey-form-inputs>
    </homey-custom-form>

    <p-divider [dt]="whiteDividerDt">or</p-divider>
    <p>Contact us at <a href="mailto:contact@myhomey.io" class="underline">contact&#64;myhomey.io</a></p>
  </ng-template>
</p-dialog>
